import { matchPath } from 'react-router-dom';

import { APP_ROUTES } from '../assets/MenuItems';
import { cleanObject, typeOf } from './object';

export const pathKeyMap = (items, basePath = '') => {
  let map = {};

  items.forEach(({
    path, key, children, ...rest
  }) => {
    const newPath = `${basePath}${path}`;

    if (key) {
      map[newPath] = {
        key,
        path,
        ...rest,
      };
    }

    if (children) {
      const nestedMap = pathKeyMap(children, `${newPath}/`);
      map = { ...map, ...nestedMap };
    }
  });

  return map;
};

export const flattenRoutes = (items, basePath = '') => items.reduce((
  flattened,
  item,
) => {
  const { path, children, ...rest } = item;

  if (!path) return flattened;

  const fullPath = `${basePath}${path}`;
  const newItem = { path, fullPath, ...rest };
  const newChildren = children ? flattenRoutes(children, `${fullPath}/`) : [];

  return [...flattened, newItem, ...newChildren];
}, []);

const DEFAULT_HOME_BY_ROLE = {
  DEVELOPER: '/developers/api-keys',
  PAYMENT_CONTROLLER: '/transactions',
  VIEW_FINANCE: '/accounts',
  DEFAULT: '/overview',
};

export const getHomeFromRole = (role) => {
  if (role) {
    return DEFAULT_HOME_BY_ROLE[role] || DEFAULT_HOME_BY_ROLE.DEFAULT;
  }

  return '/';
};

const isEmptyParam = (value) => {
  const typeOfValue = typeOf(value);

  const valueMap = {
    array: value?.length === 0,
    string: value === '' || value === 'false' || value?.endsWith?.('_aux') || value?.includes?.('date'),
  };

  return valueMap[typeOfValue] || !value;
};

export const getCountFilters = ({ filterParams, excludeParams = [] }) => {
  const params = cleanObject(filterParams);

  let count = 0;

  Object.entries(params)
    .filter(([, param]) => !isEmptyParam(param))
    .filter(([key]) => !excludeParams.includes(key))
    .forEach(([, param]) => {
      const typeOfParam = typeOf(param);

      if (typeOfParam === 'string') {
        count += 1;
      } else if (typeOfParam === 'array') {
        count += param.length;
      }
    });

  return count;
};

export const getPathInfo = ({ path }) => {
  const routesList = flattenRoutes(APP_ROUTES);
  const pathInfo = routesList.find(({ fullPath }) => matchPath({ path: fullPath }, path));

  return pathInfo;
};
